import React, { PureComponent } from 'react';
import Dropdown from '../standardAttributes/Dropdown';
import { getAvailableValuesBasedOnSelection } from './utils/tools';

export default class ShelvingAddOns extends PureComponent {
  render() {
    const options = getAvailableValuesBasedOnSelection(this.props);
    return <Dropdown {...this.props} options={options} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/ShelvingAddOns.js